export const tableRowActionsStyles = {
  iconButton: {
    padding: '6px',
    margin: '0 auto',
    display: 'flex',
    borderRadius: '8px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'action.hover',
      transform: 'scale(1.05)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
    },
  },

  menu: {
    width: 200,
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.24)',
    border: '1px solid',
    borderColor: 'divider',
    mt: 1,
    '& .MuiPaper-root': {
      borderRadius: '12px',
      overflow: 'hidden',
      backgroundColor: 'background.paper',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      width: '200px !important',
    },
    '& .MuiList-root': {
      py: 1,
      backgroundColor: 'background.paper',
    },
  },

  menuItem: {
    py: 1.5,
    px: 2.5,
    minHeight: 50,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'primary.light',
      color: 'primary.contrastText',
      transform: 'translateX(4px)',
      '& .MuiListItemIcon-root': {
        color: 'primary.contrastText',
        transform: 'scale(1.1)',
      },
    },
    '&:last-child': {
      mb: 0,
    },
  },

  editMenuItem: {
    py: 1.5,
    px: 2.5,
    minHeight: 50,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'info.light',
      color: 'info.contrastText',
      transform: 'translateX(4px)',
      '& .MuiListItemIcon-root': {
        color: 'info.contrastText',
        transform: 'scale(1.1)',
      },
    },
  },

  errorMenuItem: {
    py: 1.5,
    px: 2.5,
    minHeight: 50,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'error.light',
      color: 'error.contrastText',
      transform: 'translateX(4px)',
      '& .MuiListItemIcon-root': {
        color: 'error.contrastText',
        transform: 'scale(1.1)',
      },
    },
  },

  viewMenuItem: {
    py: 1.5,
    px: 2.5,
    minHeight: 50,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'success.light',
      color: 'success.contrastText',
      transform: 'translateX(4px)',
      '& .MuiListItemIcon-root': {
        color: 'success.contrastText',
        transform: 'scale(1.1)',
      },
    },
  },

  successMenuItem: {
    py: 1.5,
    px: 2.5,
    minHeight: 50,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'success.light',
      color: 'success.contrastText',
      transform: 'translateX(4px)',
      '& .MuiListItemIcon-root': {
        color: 'success.contrastText',
        transform: 'scale(1.1)',
      },
    },
  },

  listItemIcon: {
    color: 'inherit',
    minWidth: 44,
    transition: 'all 0.2s ease-in-out',
  },

  divider: {
    mx: 1,
    my: 0.5,
    backgroundColor: 'divider',
    opacity: 0.3,
  },

  // Icon styles
  actionIcon: {
    fontSize: '20px',
  },

  editIcon: {
    fontSize: '20px',
    color: 'info.main',
  },

  deleteIcon: {
    fontSize: '20px',
    color: 'error.main',
  },

  viewIcon: {
    fontSize: '20px',
    color: 'success.main',
  },

  // ListItemText styles
  listItemText: {
    fontSize: '0.9rem',
    fontWeight: 500,
  },

  // Menu List Props styles
  menuListProps: {
    '& .MuiMenuItem-root': {
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    },
  },

  // Slot Props Paper styles
  slotPaperProps: {
    backgroundColor: 'background.paper',
    backdropFilter: 'blur(10px)',
    border: '1px solid',
    borderColor: 'divider',
  },

  // Transition duration
  transitionDuration: {
    enter: 200,
    exit: 150,
  },
}; 